import { Helmet } from 'react-helmet-async'; 
import { Link } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography} from '@mui/material';
import RegisterForm from '../sections/auth/register/RegisterForm';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
 

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function RegisterPage() {
  const mdUp = useResponsive('up', 'md');

  return (
    <>
      <Helmet>
        <title> Register </title>
      </Helmet>

      <StyledRoot>
  
        {mdUp && (
          <StyledSection>
          <Typography style={{position:"absolute", bottom:10, left:10}}>
          Photo by <a href="https://unsplash.com/@rarchitecture_melbourne?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">R ARCHITECTURE</a> on <a href="https://unsplash.com/photos/0tKCSyLXqQM?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a>
  
          </Typography>
                 <img src="/assets/images/register.jpg" style={{objectFit:"cover", height:"100%"}} alt="login" />
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h4" gutterBottom>
           Join our community to unlock your dream potential as a home owner and a business looking to grow your market.
            </Typography> 
            <RegisterForm />
         
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
